export const isMonthAbbrFormat = (date: string): boolean => date.includes("'");

export const getMonthFullName = (monthAbbr: string): string | null => {
  const monthAbbrToFull: Record<string, string> = {
    Jan: 'January',
    Feb: 'February',
    Mar: 'March',
    Apr: 'April',
    May: 'May',
    Jun: 'June',
    Jul: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December',
  };
  return monthAbbrToFull[monthAbbr] || null;
};
